"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.errorFormatter = void 0;
function errorFormatter(error) {
    if (!error)
        return "FATAL: Error doesn't provided";
    let obj = {
        name: error.name,
        message: error.message,
        stack: error.stack,
    };
    if (error.isAxiosError) {
        const configWhitelist = ["url", "headers", "method", "httpVersion", "originalUrl", "query", "data", "params"];
        if (error.config) {
            obj = {
                ...obj,
                config: configWhitelist.reduce((acc, key) => {
                    acc[key] = error.config[key];
                    return acc;
                }, {}),
            };
        }
        if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            obj = {
                ...obj,
                response: {
                    data: error.response.data,
                    status: error.response.status,
                    headers: error.response.headers,
                },
            };
        }
        else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            obj = {
                ...obj,
                request: error.request,
            };
        }
    }
    return obj;
}
exports.errorFormatter = errorFormatter;
//# sourceMappingURL=errorFormatter.js.map